var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "box", staticClass: "box", class: { show: _vm.showing } },
    [
      _c("div", { staticClass: "header" }),
      _vm._v(" "),
      _c("div", { staticClass: "body" }, [_vm._t("default")], 2),
      _vm._v(" "),
      _vm.applyLabel
        ? _c("div", { staticClass: "footer" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-primary",
                attrs: { type: "button" },
                on: { click: _vm.onCloseBtnClick }
              },
              [_vm._v(_vm._s(_vm.applyLabel))]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.showExtraInformation
        ? _c("div", { staticClass: "guest-bl" }, [
            _c("div", { staticClass: "guest-text" }, [
              _c(
                "svg",
                {
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "128",
                    height: "128",
                    viewBox: "0 0 128 128",
                    role: "img",
                    "aria-label": "Emoji: 🧸"
                  }
                },
                [
                  _c(
                    "text",
                    {
                      attrs: {
                        x: "50%",
                        y: "50%",
                        "text-anchor": "middle",
                        "dominant-baseline": "central",
                        "font-family": "Segoe UI Emoji",
                        "font-size": "115.2",
                        fill: "#000000"
                      }
                    },
                    [_vm._v("🧸")]
                  )
                ]
              ),
              _vm._v(" "),
              _vm._m(0)
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "arrow", attrs: { "data-popper-arrow": "" } })
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("div", { staticClass: "h4" }, [
        _vm._v("\n                    Schon gewusst?\n                ")
      ]),
      _vm._v(
        "\n                Kleine Gäste, große Freude – Kinder bis 3 Jahre urlauben "
      ),
      _c("strong", [_vm._v("mietfrei")]),
      _vm._v(" in unseren Unterkünften.*\n                "),
      _c("br"),
      _vm._v(" "),
      _c("small", [
        _vm._v("*Optionale Zusatzleistungen bleiben kostenpflichtig")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }